import React from "react";
import { Container } from "./Container";
import "./styles.scss";
import numberToComma from "../../utils/numberToComma";
import cart from "../../images/cart.png";

const CardAuction = (props) => {
  const { bids, cardRight, item, price, desc, photo, action, like } = props;
  const addDefaultSrc = (e) => {
    e.target.src = cart;
  };
  return (
    <Container>
      <div className="card-item">
        <div className="card-item-body" onClick={action}>
          <div className="d-flex justify-content-between">
            <div className="heart-container">
              {like ? (
                <span style={{ color: "#0279B8" }}>
                  <i class="fa fa-heart" aria-hidden="true"></i>
                </span>
              ) : (
                <i class="fa fa-heart-o" aria-hidden="true"></i>
              )}
            </div>
            <div className="auction-item-image-container">
              <img
                src={photo}
                className="card-item-image-container rounded"
                width="100%"
                alt="deal day"
                onError={addDefaultSrc}
              />
            </div>
            <div>{cardRight}</div>
          </div>
          <div>
            <p className="auction-item-item-name">{item}</p>
            <p className="auction-item-item-desc">
              <span className="auction-bids">{bids}</span> | {desc}
            </p>
            <p className="auction-item-item-name">₦ {numberToComma(price)}</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardAuction;
